import React, { useState } from "react";
import Form from "./Fernwaerme/Form";
import Search from "./Fernwaerme/Search";
import {success} from "../libs/text";

const Fernwaerme = (props) => {

    const [finished,setFinished] = useState(false);
    const [showSuggest,setShowSuggest] = useState(true);
    const [searchObject,setSearchObject] = useState({});

    return !finished ?
        <span onClick={()=>{showSuggest?setShowSuggest(false):null}}>
            <Search onSearchComplete={setSearchObject} showSuggest={showSuggest} setShowSuggest={setShowSuggest}/>
            {searchObject.availability ? <Form setFinished={setFinished} searchObject={searchObject}/>:null}
        </span>
        :
        <section className="bg-darkgreen availability-check">
            <div className="container-fluid bg-container">
                <div className="row">
                    <div className="col-md-offset-8 col-md-4 bg"/>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-8">
                        {success}
                    </div>
                </div>
            </div>
        </section>

}

export default Fernwaerme;
